import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export default function useCheckCooldown(assetId) {
  const cooldownQuery = useQuery({
    queryKey: ['cooldown', assetId],
    queryFn: async () => {
      const { data } = await axios.post('/api/adventures/check-cooldown', {
        assetId,
      });
      return data;
    },
    enabled: !!assetId,
    refetchInterval: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchIntervalInBackground: false,
    retry: false,
  });

  const { data: cooldown, isLoading: loading } = cooldownQuery;

  return { cooldown, loading, cooldownQuery };
}
